import { cartContent } from './cart-content.js';

function cartAjaxUpdate(){
  $('.cart-reaveal').on('change', '.qty-wrapper input', function() {
    const $this = $(this);
    let $form = $this.closest('form');
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'json',
      data: $form.serialize(),
    })
    .done(function() {
      $.ajax({
        url: '/cart',
      })
      .done(function(data) {
        cartContent(data);
      })
    })
  })

}

export default cartAjaxUpdate();



// WEBPACK FOOTER //
// ../markup/assets/js/cart-ajax-update.js